import { CatalogueCopyController } from './copy/catalogue_copy.controller';
import { CatalogueCreateController } from './create/catalogue_create.controller';
import { CatalogueEditController } from './edit/catalogue_edit.controller';
import { CatalogueHistoryController } from './history/catalogue_history.controller';
import { HistoryMultipleReplace } from './history/detail/detail_viewers/history_multiple_replace.directive';
import { HistoryMultipleReplaceController } from './history/detail/detail_viewers/history_multiple_replace.controller';
import { HistoryProductAdd } from './history/detail/detail_viewers/history_product_add.directive';
import { HistoryProductAddController } from './history/detail/detail_viewers/history_product_add.controller';
import { HistorySingleReplace } from './history/detail/detail_viewers/history_single_replace.directive';
import { HistoryVariantAdd } from './history/detail/detail_viewers/history_variant_add.directive';
import { HistoryVariantAddController } from './history/detail/detail_viewers/history_variant_add.controller';
import { CatalogueHistoryDetailControllerName } from './history/detail/catalogue_history_detail.controller';
import { CatalogueListController } from './list/catalogue_list.controller';
import { CatalogueController } from './catalogue.controller';
import * as CatalogueRoutes from './catalogue.routes';
import { IControllerConstructor } from 'angular';

export const initialise = () => {

  angular.module('app.catalogue', [
    'pascalprecht.translate',
    'actora.services',
    'app.layout',
    'app.components',
    
  ])
    .controller('CatalogueController', <IControllerConstructor>CatalogueController)
    .controller('CatalogueCopyController', <IControllerConstructor>CatalogueCopyController)
    .controller('CatalogueCreateController', <IControllerConstructor>CatalogueCreateController)
    .controller('CatalogueEditController', <IControllerConstructor>CatalogueEditController)
    .controller('CatalogueHistoryController', <IControllerConstructor>CatalogueHistoryController)
    .controller('HistoryMultipleReplaceController', <IControllerConstructor>HistoryMultipleReplaceController)
    .controller('HistoryProductAddController', <IControllerConstructor>HistoryProductAddController)
    .controller('HistoryVariantAddController', <IControllerConstructor>HistoryVariantAddController)
    .directive('historyMultipleReplace', () => { return new HistoryMultipleReplace(); })
    .directive('historyProductAdd', () => { return new HistoryProductAdd(); })
    .directive('historySingleReplace', () => { return new HistorySingleReplace(); })
    .directive('historyVariantAdd', () => { return new HistoryVariantAdd(); })
    .controller('CatalogueHistoryDetailController', <IControllerConstructor>CatalogueHistoryDetailControllerName)
    .controller('CatalogueListController', <IControllerConstructor>CatalogueListController);

  CatalogueRoutes.initialise();
};